import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { MaintenanceReport } from "@/hooks/useMaintenanceReports";

/** Maintenance / unit-check issue reports filed during a specific turnover. */
export function useMaintenanceReportsForTask(cleaningTaskId: string | undefined) {
  return useQuery({
    queryKey: ["maintenance-reports-for-task", cleaningTaskId],
    queryFn: async (): Promise<MaintenanceReport[]> => {
      if (!cleaningTaskId) return [];
      const { data, error } = await supabase
        .from("maintenance_issue_reports")
        .select("*")
        .eq("cleaning_task_id", cleaningTaskId)
        .order("created_at", { ascending: true });
      if (error) throw error;
      return (data ?? []) as MaintenanceReport[];
    },
    enabled: !!cleaningTaskId,
    staleTime: 60_000,
  });
}
